module.exports = "/assets/7fdadaf5e1e95ebdaa11da3002c2cfd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JN.png
// module id = 2640
// module chunks = 0